module.exports = __webpack_public_path__ + "static/img/calculator.0e7511e.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/calculator.png
// module id = kKj1
// module chunks = 1